import { render } from "./About.vue?vue&type=template&id=dbe53080"
const script = {}

import exportComponent from "C:\\laz\\vue\\Real-World_Vue-3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__